export interface ContactModel {
  src(): any;
  entries: { [key: string]: any }[];
  bg: string;
  hasLinks: boolean;
  ref: string;
}

export const contactItems: ContactModel[] = [
  {
    hasLinks: true,
    ref: 'phone',
    bg: '#66CCFF',
    src: () => require('@shared/assets/contact_phone_icon.svg'),
    entries: [
      {
        href: 'tel:+18882930272',
        title: '+1 888-293-0272'
      },
      // {
      //   href: 'tel:+16108336400',
      //   title: '+1 610-833-6400'
      // }
    ]
  },
  {
    hasLinks: false,
    ref: 'address',
    bg: '#FF8089',
    src: () => require('@shared/assets/address_icon.svg'),
    entries: [
      {
        title: '2501 Seaport Drive,<br> Suite 410-SH Chester,<br> PA 19013'
      }
    ]
  },
  {
    hasLinks: true,
    ref: 'email',
    bg: '#6A73DF',
    src: () => require('@shared/assets/contact_email_icon.svg'),
    entries: [
      {
        href: 'mailto:info@awelearning.com',
        title: 'info@awelearning.com'
      }
    ]
  }
];
